import String from './String';

export default String;
